import gql from "graphql-tag";

export const DELETE_AGENT_MUTATION = gql`
  mutation DeleteAgent($input: DeleteAgentInput!) {
    deleteAgent(input: $input) {
      statusCode
      message
      agent {
        tenantId
        agentId
        name
        description
        llmModel
        narrativeInstructions
        codeInterpreter
        userInput
        idleSessionTimeout
        actionGroups {
          groupName
          description
          actionType
        }
      }
    }
  }
`;
